import { UIElement } from '#types/System.types';
import { CONTAINER_ELEMENT_TYPES } from '#types/System.Parameters.types';
import type { VisibilityTypeId } from '#types/System.types';
import { isVisibleInVisibilityMode } from './isVisibleInVisibilityMode';

/**
 * Single criterion visibility check (membership-only).
 *
 * Visibility filtering rules:
 * - 'internal' mode shows ALL elements
 * - undefined visibilityMode also shows all elements (same as 'internal')
 * - Other modes filter elements based on whether their visibilityTypes includes the mode
 * - Elements with no visibilityTypes are visible in all modes
 */
export const elementVisibility = (
    uiElement: UIElement, 
    visibilityMode?: VisibilityTypeId,
): boolean => {
  if (CONTAINER_ELEMENT_TYPES.includes(uiElement.uiElementType)) {
    return true;
  }

  return isVisibleInVisibilityMode({
    visibilityMode,
    visibilityTypes: 'visibilityTypes' in uiElement ? uiElement.visibilityTypes : undefined,
  });
};